export type ClassificationMethod = 'jev' | 'york_llm';

/** Normal cron classifies with Jev. The separate escalation cron classifies with York LLM. */
export function classificationMethod(run: {
  trigger?: string | null;
  config?: { pipeline?: string } | string | null;
}): ClassificationMethod {
  const pipeline = pipelineKind(run.config);
  if (pipeline === 'escalated' || run.trigger === 'escalated_cron') return 'york_llm';
  return 'jev';
}

export function classificationMethodLabel(method: ClassificationMethod): string {
  return method === 'york_llm' ? 'York LLM' : 'Jev';
}

function pipelineKind(config: { pipeline?: string } | string | null | undefined): string | null {
  if (!config) return null;
  if (typeof config === 'string') {
    try {
      const parsed: unknown = JSON.parse(config);
      if (!parsed || typeof parsed !== 'object') return null;
      const pipeline = (parsed as { pipeline?: unknown }).pipeline;
      return typeof pipeline === 'string' ? pipeline : null;
    } catch {
      return null;
    }
  }
  return typeof config.pipeline === 'string' ? config.pipeline : null;
}
